module.exports = __webpack_public_path__ + "img/Open-according-to.e2bd3234.png";